export const PATHS = {
    "taxiToRunway_14L": [
        { x: 987, y: 323, rot: 0 },
        { x: 978, y: 328, rot: 0 },
        { x: 971, y: 334, rot: 0 },
        { x: 965, y: 341, rot: 0 },
        { x: 959, y: 348, rot: 0 },
        { x: 955, y: 352, rot: 0 },
        { x: 947, y: 359, rot: 0 },
        { x: 942, y: 363, rot: 0 },
        { x: 935, y: 371, rot: 0 },
        { x: 927, y: 377, rot: 0 },
        { x: 922, y: 383, rot: 0 },
        { x: 915, y: 388, rot: 0 },
        { x: 910, y: 391, rot: 0 },
        { x: 904, y: 397, rot: 0 },
        { x: 900, y: 399, rot: 0 },
        { x: 889, y: 392, rot: 0 },
        { x: 876, y: 385, rot: 0 },
        { x: 866, y: 376, rot: 0 },
        { x: 860, y: 371, rot: 0 },
        { x: 852, y: 363, rot: 0 },
        { x: 845, y: 358, rot: 0 },
        { x: 838, y: 352, rot: 0 },
        { x: 832, y: 344, rot: 0 },
        { x: 828, y: 340, rot: 0 },
        { x: 820, y: 334, rot: 0 },
        { x: 815, y: 327, rot: 0 },
        { x: 809, y: 322, rot: 0 },
        { x: 800, y: 315, rot: 0 },
        { x: 796, y: 307, rot: 0 },
        { x: 788, y: 299, rot: 0 },
        { x: 783, y: 294, rot: 0 },
        { x: 780, y: 291, rot: 0 },
        { x: 776, y: 291, rot: 0 },
        { x: 768, y: 295, rot: 0 },
    ],
    "taxiToRunway_14R": [
        { x: 987, y: 323, rot: 0 },
        { x: 978, y: 328, rot: 0 },
        { x: 971, y: 334, rot: 0 },
        { x: 965, y: 341, rot: 0 },
        { x: 959, y: 348, rot: 0 },
        { x: 955, y: 352, rot: 0 },
        { x: 947, y: 359, rot: 0 },
        { x: 942, y: 363, rot: 0 },
        { x: 935, y: 371, rot: 0 },
        { x: 927, y: 377, rot: 0 },
        { x: 922, y: 383, rot: 0 },
        { x: 915, y: 388, rot: 0 },
        { x: 910, y: 391, rot: 0 },
        { x: 904, y: 397, rot: 0 },
        { x: 900, y: 399, rot: 0 },
        { x: 889, y: 392, rot: 0 },
        { x: 876, y: 385, rot: 0 },
        { x: 866, y: 376, rot: 0 },
        { x: 860, y: 371, rot: 0 },
        { x: 852, y: 363, rot: 0 },
        { x: 845, y: 358, rot: 0 },
        { x: 838, y: 352, rot: 0 },
        { x: 832, y: 344, rot: 0 },
        { x: 828, y: 340, rot: 0 },
        { x: 820, y: 334, rot: 0 },
        { x: 815, y: 327, rot: 0 },
        { x: 809, y: 322, rot: 0 },
        { x: 800, y: 315, rot: 0 },
        { x: 796, y: 307, rot: 0 },
        { x: 788, y: 299, rot: 0 },
        { x: 783, y: 294, rot: 0 },
        { x: 780, y: 291, rot: 0, waiting: true }, // waiting point
        { x: 776, y: 291, rot: 0 },
        { x: 768, y: 295, rot: 0 },
        { x: 761, y: 308, rot: 0 },
        { x: 754, y: 315, rot: 0 },
        { x: 751, y: 319, rot: 0 },
        { x: 745, y: 323, rot: 0 },
        { x: 741, y: 331, rot: 0 },
        { x: 736, y: 333, rot: 0 },
    ],
    "taxiToRunway_32R": [
        { x: 985, y: 347, rot: 0 },
        { x: 978, y: 352, rot: 0 },
        { x: 972, y: 357, rot: 0 },
        { x: 966, y: 368, rot: 0 },
        { x: 958, y: 373, rot: 0 },
        { x: 950, y: 385, rot: 0 },
        { x: 943, y: 389, rot: 0 },
        { x: 936, y: 395, rot: 0 },
        { x: 931, y: 402, rot: 0 },
        { x: 921, y: 409, rot: 0 },
        { x: 916, y: 415, rot: 0 },
        { x: 913, y: 419, rot: 0 },
        { x: 912, y: 419, rot: 0 },
        { x: 918, y: 426, rot: 0 },
        { x: 924, y: 436, rot: 0 },
        { x: 930, y: 439, rot: 0 },
        { x: 936, y: 446, rot: 0 },
        { x: 943, y: 451, rot: 0 },
        { x: 951, y: 459, rot: 0 },
        { x: 960, y: 469, rot: 0 },
        { x: 967, y: 479, rot: 0 },
        { x: 974, y: 488, rot: 0 },
        { x: 984, y: 497, rot: 0 },
        { x: 989, y: 502, rot: 0 },
        { x: 994, y: 507, rot: 0 },
        { x: 1000, y: 514, rot: 0 },
        { x: 1007, y: 521, rot: 0 },
        { x: 1012, y: 526, rot: 0 },
        { x: 1016, y: 531, rot: 0 },
        { x: 1025, y: 539, rot: 0 },
        { x: 1032, y: 546, rot: 0 },
        { x: 1040, y: 553, rot: 0 },
        { x: 1044, y: 559, rot: 0 },
        { x: 1050, y: 564, rot: 0 },
        { x: 1053, y: 567, rot: 0 },
        { x: 1054, y: 569, rot: 0 },
        { x: 1051, y: 576, rot: 0 },
        { x: 1047, y: 579, rot: 0 },
    ],
    "taxiToRunway_32L": [
        { x: 985, y: 347, rot: 0 },
        { x: 978, y: 352, rot: 0 },
        { x: 972, y: 357, rot: 0 },
        { x: 966, y: 368, rot: 0 },
        { x: 958, y: 373, rot: 0 },
        { x: 950, y: 385, rot: 0 },
        { x: 943, y: 389, rot: 0 },
        { x: 936, y: 395, rot: 0 },
        { x: 931, y: 402, rot: 0 },
        { x: 921, y: 409, rot: 0 },
        { x: 916, y: 415, rot: 0 },
        { x: 913, y: 419, rot: 0 },
        { x: 912, y: 419, rot: 0 },
        { x: 918, y: 426, rot: 0 },
        { x: 924, y: 436, rot: 0 },
        { x: 930, y: 439, rot: 0 },
        { x: 936, y: 446, rot: 0 },
        { x: 943, y: 451, rot: 0 },
        { x: 951, y: 459, rot: 0 },
        { x: 960, y: 469, rot: 0 },
        { x: 967, y: 479, rot: 0 },
        { x: 974, y: 488, rot: 0 },
        { x: 984, y: 497, rot: 0 },
        { x: 989, y: 502, rot: 0 },
        { x: 994, y: 507, rot: 0 },
        { x: 1000, y: 514, rot: 0 },
        { x: 1007, y: 521, rot: 0 },
        { x: 1012, y: 526, rot: 0 },
        { x: 1016, y: 531, rot: 0 },
        { x: 1025, y: 539, rot: 0 },
        { x: 1032, y: 546, rot: 0 },
        { x: 1040, y: 553, rot: 0 },
        { x: 1044, y: 559, rot: 0 },
        { x: 1050, y: 564, rot: 0 },
        { x: 1053, y: 567, rot: 0 },
        { x: 1054, y: 569, rot: 0 , waiting: true }, // waiting point
        { x: 1051, y: 576, rot: 0 },
        { x: 1047, y: 579, rot: 0}, 
        { x: 1041, y: 587, rot: 0 },
        { x: 1036, y: 589, rot: 0 },
        { x: 1030, y: 598, rot: 0 },
        { x: 1024, y: 601, rot: 0 },
        { x: 1020, y: 608, rot: 0 },
        { x: 1015, y: 611, rot: 0 },
    ],
    "takeOff_14L": [
        { x: 762, y: 306, rot: 0 },
        { x: 765, y: 314, rot: 0 },
        { x: 771, y: 319, rot: 0 },
        { x: 779, y: 323, rot: 0 },
        { x: 788, y: 329, rot: 0 },
        { x: 793, y: 339, rot: 0 },
        { x: 804, y: 347, rot: 0 },
        { x: 813, y: 359, rot: 0 },
        { x: 824, y: 370, rot: 0 },
        { x: 836, y: 383, rot: 0 },
        { x: 856, y: 401, rot: 0 },
        { x: 866, y: 416, rot: 0 },
        { x: 889, y: 436, rot: 0 },
        { x: 908, y: 455, rot: 0 },
        { x: 922, y: 467, rot: 0 },
        { x: 936, y: 484, rot: 0 },
        { x: 962, y: 510, rot: 0 },
        { x: 988, y: 535, rot: 0 },
        { x: 1024, y: 572, rot: 0 },
        { x: 1062, y: 608, rot: 0 },
    ],
    "takeOff_14R": [
        { x: 733, y: 343, rot: 0 },
        { x: 741, y: 352, rot: 0 },
        { x: 750, y: 361, rot: 0 },
        { x: 758, y: 369, rot: 0 },
        { x: 768, y: 381, rot: 0 },
        { x: 789, y: 401, rot: 0 },
        { x: 820, y: 429, rot: 0 },
        { x: 850, y: 464, rot: 0 },
        { x: 903, y: 517, rot: 0 },
        { x: 948, y: 559, rot: 0 },
        { x: 1005, y: 615, rot: 0 },
    ],
    "takeOff_32R": [
        { x: 1035, y: 583, rot: 0 },
        { x: 1029, y: 575, rot: 0 },
        { x: 1023, y: 571, rot: 0 },
        { x: 1016, y: 563, rot: 0 },
        { x: 1005, y: 553, rot: 0 },
        { x: 999, y: 547, rot: 0 },
        { x: 992, y: 539, rot: 0 },
        { x: 982, y: 527, rot: 0 },
        { x: 972, y: 519, rot: 0 },
        { x: 959, y: 506, rot: 0 },
        { x: 944, y: 493, rot: 0 },
        { x: 923, y: 471, rot: 0 },
        { x: 908, y: 455, rot: 0 },
        { x: 894, y: 440, rot: 0 },
        { x: 877, y: 423, rot: 0 },
        { x: 844, y: 391, rot: 0 },
        { x: 815, y: 362, rot: 0 },
        { x: 788, y: 335, rot: 0 },
        { x: 762, y: 307, rot: 0 },
    ],
    "takeOff_32L": [
        { x: 1008, y: 618, rot: 0 },
        { x: 999, y: 609, rot: 0 },
        { x: 988, y: 599, rot: 0 },
        { x: 972, y: 583, rot: 0 },
        { x: 953, y: 563, rot: 0 },
        { x: 926, y: 536, rot: 0 },
        { x: 876, y: 487, rot: 0 },
        { x: 820, y: 434, rot: 0 },
        { x: 730, y: 342, rot: 0 },
    ],
    "landing_14R": [
        { x: 732, y: 339, rot: 0 },
        { x: 759, y: 367, rot: 0 },
        { x: 777, y: 383, rot: 0 },
        { x: 796, y: 403, rot: 0 },
        { x: 821, y: 427, rot: 0 },
        { x: 837, y: 447, rot: 0 },
        { x: 857, y: 466, rot: 0 },
        { x: 872, y: 483, rot: 0 },
        { x: 887, y: 495, rot: 0 },
        { x: 894, y: 503, rot: 0 },
        { x: 906, y: 515, rot: 0 },
        { x: 923, y: 531, rot: 0 },
        { x: 934, y: 543, rot: 0 },
        { x: 941, y: 552, rot: 0 },
        { x: 945, y: 556, rot: 0 },
        { x: 954, y: 563, rot: 0 },
        { x: 961, y: 571, rot: 0 },
        { x: 969, y: 581, rot: 0 },
        { x: 983, y: 593, rot: 0 },
        { x: 990, y: 603, rot: 0 },
        { x: 988, y: 600, rot: 0 },
        { x: 997, y: 609, rot: 0 },
    ],
    "landing_14L": [
        { x: 762, y: 307, rot: 0 },
        { x: 802, y: 347, rot: 0 },
        { x: 841, y: 387, rot: 0 },
        { x: 875, y: 421, rot: 0 },
        { x: 901, y: 444, rot: 0 },
        { x: 916, y: 462, rot: 0 },
        { x: 932, y: 476, rot: 0 },
        { x: 944, y: 494, rot: 0 },
        { x: 963, y: 507, rot: 0 },
        { x: 974, y: 521, rot: 0 },
        { x: 982, y: 527, rot: 0 },
        { x: 990, y: 538, rot: 0 },
        { x: 1004, y: 552, rot: 0 },
        { x: 1010, y: 559, rot: 0 },
        { x: 1021, y: 567, rot: 0 },
        { x: 1028, y: 575, rot: 0 },
        { x: 1033, y: 582, rot: 0 },
    ],
    "landing_32R": [
        { x: 1040, y: 587, rot: 0 },
        { x: 1000, y: 545, rot: 0 },
        { x: 956, y: 503, rot: 0 },
        { x: 924, y: 471, rot: 0 },
        { x: 905, y: 451, rot: 0 },
        { x: 892, y: 438, rot: 0 },
        { x: 878, y: 423, rot: 0 },
        { x: 868, y: 413, rot: 0 },
        { x: 861, y: 406, rot: 0 },
        { x: 848, y: 391, rot: 0 },
        { x: 841, y: 384, rot: 0 },
        { x: 836, y: 379, rot: 0 },
        { x: 824, y: 368, rot: 0 },
        { x: 817, y: 360, rot: 0 },
        { x: 808, y: 353, rot: 0 },
        { x: 796, y: 341, rot: 0 },
        { x: 788, y: 333, rot: 0 },
        { x: 780, y: 323, rot: 0 },
        { x: 776, y: 319, rot: 0 },
        { x: 766, y: 311, rot: 0 },
        { x: 764, y: 308, rot: 0 },
    ],
    "landing_32L": [
        { x: 1035, y: 583, rot: 0 },
        { x: 1029, y: 575, rot: 0 },
        { x: 1023, y: 571, rot: 0 },
        { x: 1016, y: 563, rot: 0 },
        { x: 1005, y: 553, rot: 0 },
        { x: 999, y: 547, rot: 0 },
        { x: 992, y: 539, rot: 0 },
        { x: 982, y: 527, rot: 0 },
        { x: 972, y: 519, rot: 0 },
        { x: 959, y: 506, rot: 0 },
        { x: 944, y: 493, rot: 0 },
        { x: 923, y: 471, rot: 0 },
        { x: 908, y: 455, rot: 0 },
        { x: 894, y: 440, rot: 0 },
        { x: 877, y: 423, rot: 0 },
        { x: 844, y: 391, rot: 0 },
        { x: 815, y: 362, rot: 0 },
        { x: 788, y: 335, rot: 0 },
        { x: 762, y: 307, rot: 0 },
        { x: 1008, y: 617, rot: 0 },
        { x: 981, y: 591, rot: 0 },
        { x: 960, y: 571, rot: 0 },
        { x: 931, y: 543, rot: 0 },
        { x: 916, y: 527, rot: 0 },
        { x: 905, y: 515, rot: 0 },
        { x: 890, y: 501, rot: 0 },
        { x: 880, y: 490, rot: 0 },
        { x: 867, y: 478, rot: 0 },
        { x: 858, y: 468, rot: 0 },
        { x: 848, y: 458, rot: 0 },
        { x: 835, y: 443, rot: 0 },
        { x: 819, y: 431, rot: 0 },
        { x: 803, y: 413, rot: 0 },
        { x: 791, y: 403, rot: 0 },
        { x: 780, y: 391, rot: 0 },
        { x: 769, y: 379, rot: 0 },
        { x: 762, y: 374, rot: 0 },
        { x: 756, y: 366, rot: 0 },
        { x: 744, y: 355, rot: 0 },
        { x: 734, y: 347, rot: 0 },
        { x: 730, y: 339, rot: 0 },
    ],
    "taxiToGate_14L": [
        { x: 1045, y: 582, rot: 0 },
        { x: 1050, y: 577, rot: 0 },
        { x: 1052, y: 574, rot: 0 },
        { x: 1054, y: 568, rot: 0 },
        { x: 1050, y: 562, rot: 0 },
        { x: 1046, y: 559, rot: 0 },
        { x: 1040, y: 554, rot: 0 },
        { x: 1035, y: 549, rot: 0 },
        { x: 1027, y: 542, rot: 0 },
        { x: 1016, y: 533, rot: 0 },
        { x: 1010, y: 525, rot: 0 },
        { x: 1001, y: 517, rot: 0 },
        { x: 992, y: 507, rot: 0 },
        { x: 988, y: 503, rot: 0 },
        { x: 980, y: 497, rot: 0 },
        { x: 971, y: 487, rot: 0 },
        { x: 964, y: 479, rot: 0 },
        { x: 952, y: 466, rot: 0 },
        { x: 947, y: 458, rot: 0 },
        { x: 939, y: 450, rot: 0 },
        { x: 933, y: 444, rot: 0 },
        { x: 925, y: 437, rot: 0 },
        { x: 919, y: 432, rot: 0 },
        { x: 913, y: 426, rot: 0 },
        { x: 920, y: 419, rot: 0 },
        { x: 928, y: 411, rot: 0 },
        { x: 932, y: 407, rot: 0 },
        { x: 938, y: 401, rot: 0 },
        { x: 943, y: 397, rot: 0 },
        { x: 948, y: 388, rot: 0 },
        { x: 955, y: 383, rot: 0 },
        { x: 964, y: 375, rot: 0 },
        { x: 969, y: 369, rot: 0 },
        { x: 976, y: 363, rot: 0 },
        { x: 979, y: 359, rot: 0 },
    ],
    "taxiToGate_14R": [
        { x: 1013, y: 611, rot: 0 },
        { x: 1020, y: 607, rot: 0, waiting: true}, // waiting point
        { x: 1026, y: 601, rot: 0 },
        { x: 1030, y: 594, rot: 0}, 
        { x: 1038, y: 587, rot: 0 },
        { x: 1045, y: 582, rot: 0 },
        { x: 1050, y: 577, rot: 0 },
        { x: 1052, y: 574, rot: 0 },
        { x: 1054, y: 568, rot: 0 },
        { x: 1050, y: 562, rot: 0 },
        { x: 1046, y: 559, rot: 0 },
        { x: 1040, y: 554, rot: 0 },
        { x: 1035, y: 549, rot: 0 },
        { x: 1027, y: 542, rot: 0 },
        { x: 1016, y: 533, rot: 0 },
        { x: 1010, y: 525, rot: 0 },
        { x: 1001, y: 517, rot: 0 },
        { x: 992, y: 507, rot: 0 },
        { x: 988, y: 503, rot: 0 },
        { x: 980, y: 497, rot: 0 },
        { x: 971, y: 487, rot: 0 },
        { x: 964, y: 479, rot: 0 },
        { x: 952, y: 466, rot: 0 },
        { x: 947, y: 458, rot: 0 },
        { x: 939, y: 450, rot: 0 },
        { x: 933, y: 444, rot: 0 },
        { x: 925, y: 437, rot: 0 },
        { x: 919, y: 432, rot: 0 },
        { x: 913, y: 426, rot: 0 },
        { x: 920, y: 419, rot: 0 },
        { x: 928, y: 411, rot: 0 },
        { x: 932, y: 407, rot: 0 },
        { x: 938, y: 401, rot: 0 },
        { x: 943, y: 397, rot: 0 },
        { x: 948, y: 388, rot: 0 },
        { x: 955, y: 383, rot: 0 },
        { x: 964, y: 375, rot: 0 },
        { x: 969, y: 369, rot: 0 },
        { x: 976, y: 363, rot: 0 },
        { x: 979, y: 359, rot: 0 },
    ],
    "taxiToGate_32R": [
        { x: 768, y: 299, rot: 0 },
        { x: 772, y: 296, rot: 0 },
        { x: 776, y: 293, rot: 0 },
        { x: 787, y: 299, rot: 0 },
        { x: 796, y: 308, rot: 0 },
        { x: 803, y: 316, rot: 0 },
        { x: 810, y: 324, rot: 0 },
        { x: 819, y: 332, rot: 0 },
        { x: 824, y: 338, rot: 0 },
        { x: 832, y: 345, rot: 0 },
        { x: 838, y: 353, rot: 0 },
        { x: 844, y: 360, rot: 0 },
        { x: 851, y: 365, rot: 0 },
        { x: 856, y: 370, rot: 0 },
        { x: 862, y: 379, rot: 0 },
        { x: 872, y: 385, rot: 0 },
        { x: 879, y: 390, rot: 0 },
        { x: 887, y: 397, rot: 0 },
        { x: 896, y: 400, rot: 0 },
        { x: 905, y: 395, rot: 0 },
        { x: 912, y: 386, rot: 0 },
        { x: 918, y: 382, rot: 0 },
        { x: 924, y: 375, rot: 0 },
        { x: 930, y: 370, rot: 0 },
        { x: 936, y: 362, rot: 0 },
        { x: 942, y: 358, rot: 0 },
        { x: 951, y: 348, rot: 0 },
        { x: 958, y: 340, rot: 0 },
        { x: 968, y: 330, rot: 0 },
    ],
    "taxiToGate_32L": [
        { x: 736, y: 331, rot: 0 },
        { x: 739, y: 329, rot: 0 },
        { x: 744, y: 326, rot: 0, waiting: true }, // waiting point
        { x: 749, y: 321, rot: 0 },
        { x: 753, y: 315, rot: 0 }, 
        { x: 764, y: 307, rot: 0 },
        { x: 768, y: 299, rot: 0 },
        { x: 772, y: 296, rot: 0 },
        { x: 776, y: 293, rot: 0 },
        { x: 787, y: 299, rot: 0 },
        { x: 796, y: 308, rot: 0 },
        { x: 803, y: 316, rot: 0 },
        { x: 810, y: 324, rot: 0 },
        { x: 819, y: 332, rot: 0 },
        { x: 824, y: 338, rot: 0 },
        { x: 832, y: 345, rot: 0 },
        { x: 838, y: 353, rot: 0 },
        { x: 844, y: 360, rot: 0 },
        { x: 851, y: 365, rot: 0 },
        { x: 856, y: 370, rot: 0 },
        { x: 862, y: 379, rot: 0 },
        { x: 872, y: 385, rot: 0 },
        { x: 879, y: 390, rot: 0 },
        { x: 887, y: 397, rot: 0 },
        { x: 896, y: 400, rot: 0 },
        { x: 905, y: 395, rot: 0 },
        { x: 912, y: 386, rot: 0 },
        { x: 918, y: 382, rot: 0 },
        { x: 924, y: 375, rot: 0 },
        { x: 930, y: 370, rot: 0 },
        { x: 936, y: 362, rot: 0 },
        { x: 942, y: 358, rot: 0 },
        { x: 951, y: 348, rot: 0 },
        { x: 958, y: 340, rot: 0 },
        { x: 968, y: 330, rot: 0 },
    ]
  };